import { Component, OnDestroy, OnInit } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { GlobalService } from '../services/global.service';
import { ApiService } from '../services/api.service';
import { Router , NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { HttpResponse } from '@angular/common/http';
import { DatePipe } from '@angular/common';


@Component({
  selector: 'app-history',
  templateUrl: './history.page.html',
  styleUrls: ['./history.page.scss'],
  providers: [DatePipe]
})

export class HistoryPage implements OnInit {
  errorMessage: string = '';
  searchQuery: string = '';
  startDate: string | null = null; 
  endDate: string | null = null;
  filteredItems: any[] = [];
  isFilterApplied: boolean = false;

  index: { label: string }[] = []; //stcai-234

  onSearchClick() {
    this.startDate = '';
    this.endDate = '';
    if (this.searchQuery.trim()) {
      this.errorMessage = "";
      this.globalService.logoutLoading();
      this.callSearchAPI(this.searchQuery.trim());
      localStorage.setItem('searchedText', this.searchQuery.trim());
      this.globalService.dismissLoading();
    } else {
      // Handle empty search query or show a message
      this.filteredItems = [];
    }
  }


  onSearchInput(event: any) {
    this.errorMessage = "";
    this.startDate = '';
    this.endDate = '';
    const inputValue = event.target.value;
    this.searchQuery = inputValue;

    const searchedText: string | null = localStorage.getItem('searchedText');

    try{
      if(searchedText && !inputValue){
        this.globalService.logoutLoading();
        this.currentPage = 1;
        this.goToPageNumber = 1;

        this.loadPageData(1);
        this.globalService.dismissLoading();
      }

    }catch(error){
        console.log('error!!!')
    }


    // You can add logic here, such as debounced API calls or filtering

  }

  callSearchAPI(searchText: string){
    try{
        const fromMyHistoryPage: boolean = true;
        this.apiService.searchText(searchText,this.currentPage,fromMyHistoryPage).subscribe(response => {
          const dataArray = response.data;
          const totalPageCount = response.totalCount;
          localStorage.setItem('totalCountData', totalPageCount);
          // this.totalPages = totalPageCount/100;
          this.totalPages = Math.ceil(totalPageCount / 20);
          console.log("Total page count",this.totalPages)

          this.data = Array.isArray(dataArray) ? dataArray : [];
          this.data.forEach((item, i) => {
            console.log("TTTThis index is:",this.index)
            // item.Index = this.findTextIndex(this.index,item.Text); // Assigning 1-based index
            item.Index = this.findTextIndex(this.index,item.Text); // Assigning 1-based index
            console.log("INININININdex",item.Index);
            // item.Index = "1"; // Assigning 1-based index
            debugger;
          });



        }, error => {
          
          console.error('Ssearching error:', error);
          this.errorMessage = 'Data not found !!!';
          this.goToPageNumber = 1;
          this.totalPages = 1;
        });
      }catch(error){
        
        console.log('Form is invalid');
      }
  }

  clientname: string | null | undefined;

  data: any[] = [];
  currentPage = 1;
  totalPages = 3;
  goToPageNumber: number | null = this.currentPage;

  findTextIndex(data: string | any[], searchText: any) {
    console.log("TTTType",typeof data);
  if(Array.isArray(data)){
    for (let i = 0; i < data.length; i++) {
        for (let key in data[i]) {
            if (Array.isArray(data[i][key])) {
                for (let j = 0; j < data[i][key].length; j++) {
                    if (data[i][key][j].Text === searchText) {
                        return `${key}:${j + 1}`; // Return the key and 1-based index of the matching entry
                    }
                }
            }
        }
    }
    return 'No-Index';
  }else{
    return null;
  }
}

  retriveSavedDataFun(page:any) {
    this.errorMessage = "";
    const lang = localStorage.getItem('language');
    const cate = localStorage.getItem('textCategory');
    const clientId: string | null = localStorage.getItem('userId');
    const passClientId: boolean = true;
     
    this.apiService.retriveSavedData(lang,cate,clientId,page,passClientId).subscribe(
    (response: HttpResponse<any>) => {
      console.log("RrRrRrRr is:",response);
      const dataArray = response.body.data;
      const totalPageCount = response.body.totalCount;
      this.totalPages = Math.ceil(totalPageCount / 20);
      console.log("Total page count",this.totalPages)
      this.data = Array.isArray(dataArray) ? dataArray : [];

      this.data.forEach((item, i) => {
        item.Index = this.findTextIndex(this.index,item.Text); // Assigning 1-based index
        console.log("INININININdex",item.Index);
        // item.Index = "1"; // Assigning 1-based index
        debugger;
      });
    },
    (err) => {
        console.log(err);
    }
    );
  }

  userName !: string | null;
  userLanguage !: string | null;

  selectedOption : string | null = 'all';
  


  constructor(private router:Router,private apiService:ApiService,private alertController: AlertController,private globalService:GlobalService,private datePipe: DatePipe) {
    this.startDate = '';
    this.endDate = '';
   }

   ionViewWillLeave(): void {
    localStorage.removeItem('searchedText');
    localStorage.removeItem('textCategory');
    localStorage.removeItem('selectedOptionUser');
    localStorage.removeItem('totalCountData');
    console.log('localStorage from History Page cleared when leaving the page');
  }
  

  
  ngOnInit(): void {

    this.index = this.globalService.getGlobalVariable()

    if(!this.index){
      this.router.navigate(['/menu']);
    }
    // this.textFromServer = '';

    // Subscribe to router events to detect navigation
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)  // Filter for NavigationEnd event
    ).subscribe(() => {
      // Check if the current route matches 'history' (or whatever your route path is)
      // console.log("Initial Current page:",this.currentPage)

      if (this.router.url.includes('history')) {
        this.retriveSavedDataFun(this.currentPage);  // Call the function when navigating to 'history' page
      }
    });
  }

  ionViewDidEnter(){
    this.index = this.globalService.getGlobalVariable()
  }

  goToMenu() {
    this.router.navigate(['/menu']);
  }
  
  onEnterKey(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.onSearchClick();
    }
  }
  onKeyPress(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.goToSpecificPage();
    }
  }
  async confirmLogout() {
    // if(this.isRecording || this.hasUnsavedAudioData()){  
      const alert = await this.alertController.create({
            header: 'Confirm Logout',
            message: 'Are you sure you want to log out?',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        // Do nothing when the user cancels
                    }
                },
                {
                    text: 'Logout',
                    handler: async () => {
                        // this.stopRecordingOnly();
                        await this.LogoutFunction();
                    }
                }
            ]
        });

        await alert.present();
      // }else{
      //   await this.LogoutFunction();
      // }
  }

  async LogoutFunction(){
  
      try{
          this.globalService.logoutLoading();
          const res:any = await this.apiService.logoutUser().toPromise();
              

          localStorage.removeItem('authenticationKey');
          localStorage.removeItem('accent');
          localStorage.removeItem('age');
          localStorage.removeItem('gender');
          localStorage.removeItem('userId');
          localStorage.removeItem('userName');
          localStorage.removeItem('language');
          localStorage.removeItem('userRole');
          this.globalService.dismissLoading();
        
          this.router.navigate(['login']);    
      }catch(error){
        console.log("Error:", error);
        // this.globalService.dismissLoading();
        this.router.navigate(['login']);

      }
      
  };


  goToPage(page: number) {
    try{
      const inputValue = Number(this.goToPageNumber);

      // if (inputValue < this.totalPages) {
        this.globalService.logoutLoading();
        // if (page >= 1 && page <= this.totalPages) {
          this.currentPage = page;
          this.goToPageNumber = page; // Keep them in sync
          // Add logic here to fetch/display data for the current page

          this.loadPageData(this.currentPage);
          this.globalService.dismissLoading();
        // }
      // }
    }catch(error){
      console.log("Error:",error);
    }
  }

  loadPageData(page: number) {
    // Logic to fetch data based on `page`
    console.log("This is the page number:",page)
    if(this.startDate && this.endDate){
      this.onFilterClickfun(page)
    }else{
      this.retriveSavedDataFun(page)
    }
  }

  onFilterClickfun(page:number){
    this.onFilterClick(page)
  }

  // Method to go to the page entered in the input
  goToSpecificPage() {
    if (this.goToPageNumber) {
      this.goToPage(this.goToPageNumber);
    }
  }


  getPages(): number[] {
    let pages = [];
    const start = Math.max(1, this.currentPage - 2);
    const end = Math.min(this.totalPages, this.currentPage + 2);

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  }

  

  putSavedDataFun(selectedValue: boolean, item: any) {
    const AudiopathId = item.AudiopathId;
    const ClientId = item.ClientId
    const Usable = selectedValue

    console.log("AudiopathId:",AudiopathId)
    console.log("ClientId:",ClientId)
    console.log("Usable:",Usable)
    this.apiService.updateUsableValue(AudiopathId,ClientId,Usable).subscribe(
     (response) => {
       console.log("response is:",response);
      //  this.data = response
     },
     (err) => {
       console.log(err);
     }
   );
 }


 putSavedDataFunForInterpretation(selectedValue: boolean, item: any) {
  const AudiopathId = item.AudiopathId;
  const ClientId = item.ClientId
  const intepretationOnly = selectedValue

  console.log("AudiopathId:",AudiopathId)
  console.log("ClientId:",ClientId)
  console.log("Usable:",intepretationOnly)
  this.apiService.updateInterpretationValue(AudiopathId,ClientId,intepretationOnly).subscribe(
   (response) => {
     console.log("response is:",response);
    //  this.data = response
   },
   (err) => {
     console.log(err);
   }
 );
}

  onUsableChange(event: any, item: any) {
    const selectedValue = event.detail.checked; // true if toggle is on, false if off
    console.log('Selected value:', selectedValue);
    console.log('Item:', item);
    // You can now use `selectedValue` and `item` as needed

    this.putSavedDataFun(selectedValue,item);
  }
  
  onIsForInterpretationOnlyChange(event: any, item: any){
    console.log("Enter to onIsForInterpretationOnlyChange function only");
    console.log('Item:', item);
    const selectedValue = event.detail.checked;
    this.putSavedDataFunForInterpretation(selectedValue,item);

  }


  
  //Date time implemented
  onFilterClick(page:number){
    this.searchQuery = '';
    this.errorMessage = '';
    const searchText = 'test search';
    // const page = 1;
    const fromMyHistoryPage = true;
    const startDate = this.startDate;
    const endDate = this.endDate;
      try{
        this.errorMessage = "";
        this.globalService.logoutLoading();
        this.apiService.filterTextDatewise(searchText,page,fromMyHistoryPage,startDate,endDate).subscribe(response => {
          const dataArray = response.data;
          const totalPageCount = response.totalCount;
          localStorage.setItem('totalCountData', totalPageCount);
          this.totalPages = Math.ceil(totalPageCount / 20);
          console.log("Total page count",this.totalPages)
          this.data = Array.isArray(dataArray) ? dataArray : [];
          this.data.forEach((item, i) => {
            item.Index = this.findTextIndex(this.index,item.Text); // Assigning 1-based index
            
          });
          this.globalService.dismissLoading();
        }, error => {
          
          console.error('Ssearching error:', error);
          this.errorMessage = 'Data not found !!!';
          this.goToPageNumber = 1;
          this.totalPages = 1;
          this.globalService.dismissLoading();
        });
      }catch(error){
        
        console.log('Form is invalid');
      }

  }

  getStartDate(): string {
    return this.startDate ? this.datePipe.transform(this.startDate, 'dd/MM/yy') || '' : '';
  }

  getEndDate(): string {
    return this.endDate ? this.datePipe.transform(this.endDate, 'dd/MM/yy') || '' : '';
  }

  formatSelectedDate(date: string | null): string {
    return date ? this.datePipe.transform(date, 'yyyy-MM-dd') || '' : '';
  }

  private updateDate(dateType: string, date: string): void {
    if (dateType === 'startDate') {
      this.startDate = date;
    } else if (dateType === 'endDate') {
      this.endDate = date;
    }
  }


  onDateChange(dateType: string, event: any): void  {
    if (this.isFilterApplied) {
      this.isFilterApplied = false;
    }
    const date = event.detail?.value || event.target.value; 
  
    if (date && !isNaN(Date.parse(date))) {
      this.updateDate(dateType, date);  
    } else {
      console.error('Invalid date selected');
      return; 
    }
  
    if (dateType === 'startDate') {
      this.startDate = date;
    } else if (dateType === 'endDate') {
      this.endDate = date;
    }
  }
  // applyFilter(){
  //   console.log("Filter applied");
  //   this.onFilterClick(1);

  // }

  applyFilter(): void {
    this.currentPage = 1;
    this.goToPageNumber = 1;
    if (this.isFilterApplied) {
      this.globalService.logoutLoading();
      this.startDate = '';
      this.endDate = '';
      this.isFilterApplied = false;
      // console.log(`Applying filter from ${this.startDate} to ${this.endDate}`);
      // this.onFilterClick(1);
      this.retriveSavedDataFun(1)
      this.globalService.dismissLoading();
    } else {
      this.globalService.logoutLoading();
      this.isFilterApplied = true;
      if (this.startDate && this.endDate) {
        console.log(`Applying filter from ${this.startDate} to ${this.endDate}`);
        this.onFilterClick(1);
      } else {
        console.warn('One or both dates are missing. Filter may not work as expected.');
      }
      this.globalService.dismissLoading();
    }
  }




  // Define the list of allowed client names
  allowedClients: Set<string> = new Set(['BAS','sabir', 'Harry', 'susan', 'joost', 'conny001', 'rb99', 'sushmita', 'rikesh']);
  // allowedClients: Set<string> = new Set(['BAS','sabir' 'Harry', 'joost', 'conny001', 'rb99', 'sushmita', 'rikesh']);

  async goToAdminPage() {
    this.clientname = localStorage.getItem('userName');
      // Check if clientname is in the allowedClients set
      if (this.clientname && this.allowedClients.has(this.clientname)) {
        this.router.navigate(['/admin']);
      } else {
        // Show a popup message if not allowed
        const alert = await this.alertController.create({
          header: 'Access Denied',
          message: 'Sorry, you do not have permission to access this page.',
          buttons: ['OK']
        });
        await alert.present();
      }
    }

    formatDate(dateString: string): string {
      const date = new Date(dateString);
    
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
      const day = date.getDate().toString().padStart(2, '0');
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const seconds = date.getSeconds().toString().padStart(2, '0');
    
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }

    async deleteAudioFile(item: any) {
      // console.log("DDDDDdeleted item is:",item);
      const alert = await this.alertController.create({
        header: 'Confirm Delete',
        message: 'Are you sure you want to delete this audio file?',
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
            handler: () => {
              console.log('Delete canceled');
            }
          },
          {
            text: 'Delete',
            handler: () => {
              console.log("fetch the history");
              this.globalService.logoutLoading();
    
              this.apiService.deleteAudioFile(item.AudiopathId).subscribe(response => {
                console.log('Deleted Audio is:', response);
    
                if (!response) {
                  console.error("No response from API");
                  this.globalService.dismissLoading();
                  return;
                }
                this.updateRowValueOnDeleteSoundFile(item);
                this.globalService.dismissLoading();
    
                // Optionally remove the deleted item from the list
                // this.historyData = this.historyData.filter(x => x.AudiopathId !== item.AudiopathId);
    
              }, error => {
                console.error('Error on delete audio file:', error);
                this.globalService.dismissLoading();
              });
            }
          }
        ]
      });
    
      await alert.present();
    }

    updateRowValueOnDeleteSoundFile(item:any) {
      const index = this.data.indexOf(item);
      if (index !== -1) {
        this.data.splice(index, 1);
      }
    }
    

}


